<template>
  <div class="tw-flex tw-flex-col tw-min-h-0 tw-gap-4">
    <div class="tw-pt-1 tw-h-[60vh] tw-min-h-0 tw-flex tw-flex-col tw-overflow-hidden">
      <CandidatesGraphqlTable @row-click="clickedTrustedContactRow">
        <template #action="{ row }">
          <WdsButton
            v-if="trustedContactCanBeHired(row)"
            primary
            sm
            data-test="select-trusted-contact"
            @click.stop="selectTrustedContact(row)"
          >
            {{ $t('Select') }}
          </WdsButton>
        </template>
        <template #no-results>
          <NoTrustedContactsFound />
        </template>
      </CandidatesGraphqlTable>
    </div>

    <div class="direct-hire-modal-bottom tw-shrink-0 tw-pt-4 tw-px-6">
      <div
        class="tw-bg-indigo-50 tw-rounded-lg tw-p-4 tw-flex tw-items-center tw-gap-4 tw-border tw-border-indigo-200"
      >
        <WdsAlert
          class="tw-flex-1"
          icon
          info
          :title="$t('Hiring someone for the first time?')"
          :description="$t('You\'ll need to add them as a trusted contact first')"
        />
        <WdsButton
          primary
          class="tw-shrink-0"
          :href="laravelNamedRoute(namedRoutes.contacts.index, '')"
        >
          {{ $t('Open trusted contacts') }}
        </WdsButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WdsButton, WdsAlert } from '@worksome/wds-components'
import { provide } from 'vue'
import { $t } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { TrustedContact } from '@/components/Job/hiring-types'
import NoTrustedContactsFound from '@/components/Contacts/CompanyFreelancer/NoTrustedContactsFound.vue'
import CandidatesGraphqlTable from '@/components/Contacts/CandidatesGraphqlTable.vue'
import { TableInModal } from '@/components/GraphqlDataTable/injection'

interface Props {
  trustedContact?: TrustedContact
}

const emit = defineEmits(['cancel', 'confirm', 'update:trusted-contact'])

const props = defineProps<Props>()

provide(TableInModal, true)

function normalizeRowToTrustedContact(row: any): TrustedContact | null {
  if (!row?.id || !row?.worker?.id) return null
  return {
    id: row.id,
    workerId: row.worker.id,
    avatar: row.worker.avatar ?? '',
    name: row.worker.name ?? '',
    title: row.worker.jobTitle ?? '',
  }
}

const selectTrustedContact = (row) => {
  const trustedContact = normalizeRowToTrustedContact(row)
  if (!trustedContact) return
  emit('update:trusted-contact', trustedContact)
  emit('confirm', trustedContact)
}

const trustedContactCanBeHired = (trustedContact): boolean =>
  trustedContact?.worker?.viewerCanOfferJob === true

const clickedTrustedContactRow = (trustedContact) => {
  if (trustedContactCanBeHired(trustedContact)) {
    selectTrustedContact(trustedContact)
  }
}
</script>
